/**
 * Represents the possible site plan layers to support on top of Community Interactive Site Plans.
 */
export default class SitePlanLayer {
    static get LotNumbers() {
        const configuration = {
            name: 'LotNumbers',
            id: 'lot_numbers',
        };
        return this.getInstance('LotNumbers', configuration);
    }
  
    static get StreetNames() {
        const configuration = {
            name: 'StreetNames',
            id: 'street_names',
        };
        return this.getInstance('StreetNames', configuration);
    }
  
    static get Walkway() {
        const configuration = {
            name: 'Walkway',
            id: 'walkway',
        };
        return this.getInstance('Walkway', configuration);
    }
  
    static get Grass() {
        const configuration = {
            name: 'Grass',
            id: 'grass',
        };
        return this.getInstance('Grass', configuration);
    }

    static get Ground() {
        const configuration = {
            name: 'Ground',
            id: 'ground',
        };
        return this.getInstance('Ground', configuration);
    }

    static get LotPolygons() {
        const configuration = {
            name: 'LotPolygons',
            id: 'lot_polygons',
        };
        return this.getInstance('LotPolygons', configuration);
    }

    static get Street() {
        const configuration = {
            name: 'Street',
            id: 'street',
        };
        return this.getInstance('Street', configuration);
    }

    static get Lots() {
        const configuration = {
            name: 'MainLots',
            id: 'lots',
        };
        return this.getInstance('MainLots', configuration);
    }

    static get Water() {
        const configuration = {
            name: 'Water',
            id: 'water',
        };
        return this.getInstance('Water', configuration);
    }

    static get Golf() {
        const configuration = {
            name: 'Golf',
            id: 'golf',
        };
        return this.getInstance('Golf', configuration);
    }
  
    static fromKey(key) {
      const map = {
        LotNumbers: SitePlanLayer.LotNumbers,
        StreetNames: SitePlanLayer.StreetNames,
        Walkway: SitePlanLayer.Walkway,
        Grass: SitePlanLayer.Grass,
        Ground: SitePlanLayer.Ground,
        LotPolygons: SitePlanLayer.LotPolygons,
        Street: SitePlanLayer.Street,
        MainLots: SitePlanLayer.Lots,
        Water: SitePlanLayer.Water,
        Golf: SitePlanLayer.Golf,
      };
      
      return map[key];
    }
  
    static getInstance(key, configuration) {
        configuration.name = key;
    
        if (!this.instances[key]) {
          this.instances[key] = new SitePlanLayer(configuration);
        }
        return this.instances[key];
    }
  
    constructor(configuration) {
        this.name = configuration.name;
        this.id = configuration.id;
    }
  
    toString() {
      return `${this.name}`;
    }
  }
  
  Object.defineProperty(SitePlanLayer, 'instances', { value: {} });
  